import { render, staticRenderFns } from "./Iframe.vue?vue&type=template&id=0ff431e6&"
import script from "./Iframe.vue?vue&type=script&lang=js&"
export * from "./Iframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports